import { defineComponent, ref, onMounted } from 'vue'
import UIKit from 'uikit'

import PointPage from '@/organizations/_default/point'
import Banner from '@/organizations/cosmo/default/components/Banner.vue'
import CosmoHeader from '@/organizations/cosmo/default/components/CosmoHeader.vue'
import CosmoFooter from '@/organizations/cosmo/default/components/CosmoFooter.vue'
import BusinessHours from '@/organizations/cosmo/default/components/BusinessHours.vue'
import MaintenanceLink from '@/organizations/cosmo/default/components/MaintenanceLink.vue'
import PointSearchConditions from '@/components/common/PointSearchConditions.vue'
import ProductModal from '@/components/common/ProductModal.vue'

import { Filters } from '@/services/Filters.ts'


export default defineComponent({
  extends: PointPage,
  components: {
    Banner,
    CosmoHeader,
    CosmoFooter,
    BusinessHours,
    PointSearchConditions,
    ProductModal,
    MaintenanceLink,
  },
  setup(props, context) {
    const page = PointPage.setup(props, context)

    /**
     * カーメンテナンス予約リンクのラベル
     */
    const maintenanceLinkLabel = 'ネットで来店予約'
    /**
     * カーメンテナンス予約リンクのフォーマット
     * {id} にストアIDが入る
     */
    const maintenanceLinkFormat = 'https://timy.jp/{id}?reserve_channel=4&utm_campaign=alliance&utm_medium=Affiliates&&utm_source=ceh_map'
    /**
     * ストアIDが格納されている追加フィールドのキー
     */
    const maintenanceLinkExtraFieldKey = 'Timyリンク用ストアID'

    /**
     * 検索条件のプレビュー表示件数 この数値より上であれば格納されてボタンが表示される
     */
    const previewConditionsCount = 4

    // 選択した条件とその他を分割するために利用
    const searchConditionsState = ref({
      isSelected: false,
      selectedIds: [],
      notSelectedIds: []
    })

    /**
     * UIKitのnavコンポーネントインスタンス
     * サービスリストの折りたたみ/展開を制御するために使用
     * onMountedでDOM要素（.service-list-summary）に紐づけられる
     * @type {object|null}
     */
    let serviceListNav = null

    /**
     * サービスリストの折りたたみ/展開状態
     * @type {object}
     */
    const isServiceListOpen = ref(false)

    if (sessionStorage) {
      const cache = Filters.cache.load()
      const filterIds = cache?.search_conditions || []

      // 選択した条件とその他を分割
      if (filterIds && filterIds.length > 0) {
        const ids = Filters.getPointFilters(
          Filters.TYPE_SEARCH_CONDITIONS,
          page.point.value,
          Filters.getFilterTree(Filters.TYPE_SEARCH_CONDITIONS)
        ).filter(c => c.is_show).map(c => c.id)

        if (ids.length > 0) {
          searchConditionsState.value.isSelected = true
          ids.forEach((id) => {
            if (filterIds.includes(id)) {
              searchConditionsState.value.selectedIds.push(id)
            } else {
              searchConditionsState.value.notSelectedIds.push(id)
            }
          })
        }
      }
    }

    /**
     * 検索条件の件数を取得
     * @returns {number} 検索条件の数
     */
    const getConditionsCount = () => {
      const uniqueNames = new Set()
      return Filters
        .getPointFilters(
          Filters.TYPE_SEARCH_CONDITIONS,
          page.point.value,
          Filters.getFilterTree(Filters.TYPE_SEARCH_CONDITIONS)
        )
        .filter(condition => condition.is_show)
        .reduce((count, condition) => {
          if (!uniqueNames.has(condition.name)) {
            uniqueNames.add(condition.name)
            return count + 1
          }
          return count
        }, 0)
    }

    /**
     * 店舗の持つ有効な検索条件の件数
     * @type {number}
     */
    const conditionsCount = getConditionsCount()

    /**
     * コンポーネントの名前に合わせて変数名をproductModalRefとするが
     * モーダルに表示する内容は絞り込みの説明
     */
    const productModalRef = ref(null)
    const selectedSearchCondition = ref({})

    /**
     * FileterInfoのクリックイベント
     * 共通のproductModalを利用するために、propsで設定する
     */
    const onClickedSearchCondition = (searchCondition) => {
      selectedSearchCondition.value = searchCondition
      productModalRef.value.open()
    }

    /**
     * 検索上件のアイコンを表示するか
     * true: 表示する
     */
    const searchConditionIsOpenable = (serachCondition) => {
      return serachCondition.extra_fields?.description
    }


    /**
     * サービスリストの開閉をトグル
     * @param {Object} searchCondition
     */
    const toggleServiceList = async (event) => {
      if (event) {
        // クリックイベントをキャンセル
        event.preventDefault()
        event.stopPropagation()
      }
      
      if (serviceListNav) {
        // UIKitのnavコンポーネントを利用してサービスリストをトグル
        serviceListNav.toggle()
      }
      isServiceListOpen.value = !isServiceListOpen.value
    }

    onMounted(() => {
      const element = document.querySelector('.service-list-summary')
      serviceListNav = UIKit.nav(element)
    })

    /**
     * ポイントのストアIDからカーメンテナンス予約リンクを生成
     * @param {Object} point
     * @returns {string} url
     */
    const genarateMaintenanceLink = (point) => {
      const storeId = point.extra_fields?.[maintenanceLinkExtraFieldKey]
      if (!storeId) {
        return ''
      }

      return maintenanceLinkFormat.replace(/\{id\}/g, storeId)
    }

    return {
      ...page,
      Banner,
      BusinessHours,
      MaintenanceLink,
      maintenanceLinkLabel,
      selectedSearchCondition,
      productModalRef,
      searchConditionsState,
      onClickedSearchCondition,
      searchConditionIsOpenable,
      genarateMaintenanceLink,
      toggleServiceList,
      isServiceListOpen,
      conditionsCount,
      previewConditionsCount,
    }
  }
})
